import { render, staticRenderFns } from "./IdentifyRedirectContent.vue?vue&type=template&id=431a7135&scoped=true&"
import script from "./IdentifyRedirectContent.vue?vue&type=script&lang=ts&"
export * from "./IdentifyRedirectContent.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyRedirectContent.vue?vue&type=style&index=0&id=431a7135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a7135",
  null
  
)

export default component.exports